import * as data from './data';
const Mock = require('mockjs');
// 例子
Mock.mock('/api/test/', 'post', data.test);
Mock.mock(/\/api\/test\/\d/, 'get', data.testByGet);
Mock.mock('/api/testCom/', 'post', data.testCompany);
// Mock.mock('/online_shop/list', 'post', data.test);

// Mock.mock(/\/api\/common\/brand\/\d/, 'get', data.details);
// Mock.mock('/api/common/brand/list', 'post', data.list);
// Mock.mock(`/api/common/brand/`, 'put');
// Mock.mock(`/api/common/brand/`, 'post');
// Mock.mock(`/api/common/brand/delete`, 'post');

// Mock.mock(/\/aido\/mall\/order\/\d/, 'get', data.details);
// Mock.mock('/aido/mall/order/list', 'post', data.list);
// Mock.mock(`/aido/mall/order/`, 'put');
// Mock.mock(`/aido/mall/order/`, 'post');
// Mock.mock(`/aido/mall/order/delete`, 'post');

// import crowdOrderData from './crowdOrder';
//
//
// Mock.mock('/aido/mall/order/crowdOrder/summary', 'get', crowdOrderData.summary);
//
// Mock.mock('/aido/mall/order/crowdOrder/list', 'post', crowdOrderData.list);
